import { version } from "../routes/version/-version.json"
import { objectToQueryString } from "./objectToQueryString"
import type * as Api from "../@client/api"
import { handleResponse } from "./handle-response"

export async function get<ActionName extends keyof Api.GET>(
  url: ActionName,
  input: Api.Input[ActionName],
  requestInit?: RequestInit
) {
  const headers = new Headers(requestInit?.headers)
  headers.set("Client-Version", version)

  try {
    return await handleResponse<Api.Output[ActionName]>(
      await fetch(url + "?" + objectToQueryString(input), {
        method: "GET",
        ...requestInit,
        headers,
      })
    )
  } catch (error) {
    throw error
  }
}
